<script setup lang="ts"></script>

<template>
  <div class="kg-card-course__loading">
    <a-skeleton-image class="loading-image" />

    <div class="loading-body">
      <a-skeleton active />
    </div>
  </div>
</template>

<style lang="scss">
@use './styles.scss';
</style>
